/**
 * @file Custom print related queries.
 */

import gql from 'graphql-tag';

import {
  PurchasedCustomPrintDetails,
  AlbumCustomPrintDetails,
} from '../fragments/custom-prints';

export const PurchasedCustomPrintForConfig = gql`
  query purchasedCustomPrintForConfig($id: RecordID!) {
    purchasedCustomPrint(id: $id) {
      ...PurchasedCustomPrintDetails
    }
  }
  ${PurchasedCustomPrintDetails}
`;

export const AccountPurchasedCustomPrints = gql`
  query consumerAccountPurchasedCustomPrints(
    $orderStatuses: [CustomPrintOrderStatusEnum]
    $customPrintTypes: [CustomPrintTypeEnum]
  ) {
    me {
      id
      purchased_custom_prints(
        order_statuses: $orderStatuses
        custom_print_types: $customPrintTypes
        slice: { limit: 999 }
      ) {
        total
        records {
          id
          name
          photos_no
          custom_print_type
          selected_identity {
            id
            matched_photos_extended {
              total
            }
          }
        }
      }
    }
  }
`;

export const AlbumCustomPrintForCheckoutFromAlbum = gql`
  query albumWithCustomPrint($id: RecordID!) {
    album(id: $id) {
      id
      # Collages only for now.
      custom_prints(slice: { limit: 1 }, custom_print_types: [COLLAGE]) {
        records {
          ...AlbumCustomPrintDetails
        }
      }
    }
  }
  ${AlbumCustomPrintDetails}
`;
